import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as api from '../service/api';
import * as auth from '../service/auth';

function Watch() {

    const { conteudo_uuid } = useParams()

    // const history = useHistory()
    const [canal, setCanal] = useState(null)
    const [canais, setCanais] = useState([])
    const [loading, setLoading] = useState(true)

    function mudarCanal(canal) {
        setCanal(canal)
        setLoading(true)
        setTimeout(() => {
            let element = document.querySelector('#iframe');
            element.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }, 500);
    }

    useEffect(() => {

        if (canal?.conteudo_uuid) {
            api.retonarConteudoPorUUID(canal.conteudo_uuid)
                .then(res => {
                    if (res.success) {
                        setCanal(res.conteudo)
                        setLoading(false)
                    }
                })
        }
    }, [canal?.conteudo_uuid])

    useEffect(() => {
        api.retornarCanaisWEBAoVivo()
            .then(res => {
                if (res.success) {
                    setCanais(res.canais)
                    if (!canal?.conteudo_uuid && res.canais.length > 0) {
                        const primeiroCanal = res.canais[0]
                        setCanal(primeiroCanal)
                    }
                }
            })
    }, [])

    return (
        <div className="flex flex-row" style={{ height: 'calc(100vh - 64px)' }}>

            {/* Sidebar - lista de canais */}
            <aside className="hidden lg:flex flex-col w-56 bg-gray-900 border-r border-gray-800 flex-shrink-0 overflow-hidden">
                <div className="px-4 py-3 border-b border-gray-800 flex-shrink-0">
                    <span className="text-sm font-semibold text-gray-500 uppercase tracking-widest">Canais ao vivo</span>
                </div>
                <div className="flex flex-col overflow-y-auto flex-1">
                    {canais.map((c, index) => (
                        <button
                            key={index}
                            onClick={() => mudarCanal(c)}
                            className={`flex items-center gap-3 px-4 py-2 hover:bg-gray-800 transition-colors text-left w-full flex-shrink-0 ${c.conteudo_uuid === canal?.conteudo_uuid ? 'bg-gray-800 border-l-2 border-orange-500' : ''}`}
                        >
                            <div className="relative flex-shrink-0">
                                <img className="w-8 h-8 rounded object-contain bg-gray-700" src={c.icone} alt={c.titulo} />
                            </div>
                            <div className="flex flex-col min-w-0">
                                <span className="text-base font-medium text-white truncate">{c.titulo}</span>
                                <span className="text-sm text-gray-500 truncate">{c.evento?.titulo}</span>
                            </div>
                        </button>
                    ))}
                </div>
            </aside>

            {/* Conteúdo principal */}
            <main className="flex flex-col lg:flex-row flex-1 min-w-0 overflow-hidden">

                {/* Player */}
                <div id="iframe" className="flex-1 bg-black min-h-0">
                    {(canal && canal.link) && (
                        <iframe className="w-full h-full" allowFullScreen src={`${canal?.link}?token=${auth.getToken()}`}></iframe>
                    )}
                </div>

                {/* Info panel */}
                <div className="lg:w-72 flex-shrink-0 bg-gray-900 border-l border-gray-800 p-5 flex flex-col gap-3 overflow-y-auto">
                    {loading ? (
                        <div className="animate-pulse flex flex-col gap-3">
                            <div className="h-3 bg-gray-700 rounded w-1/4"></div>
                            <div className="h-5 bg-gray-700 rounded w-3/4"></div>
                            <div className="h-3 bg-gray-700 rounded w-1/2"></div>
                            <div className="h-3 bg-gray-700 rounded w-2/3"></div>
                        </div>
                    ) : (
                        <>
                            <span className="bg-red-600 text-white text-sm font-bold px-2 py-0.5 rounded w-fit">AO VIVO</span>
                            <h1 className="text-lg font-bold leading-snug">{canal?.evento?.titulo}</h1>

                            {canal?.evento?.categorias && (
                                <div className="flex flex-wrap gap-1">
                                    {canal.evento.categorias.split(',').map((cat, i) => (
                                        <span key={i} className="text-sm bg-gray-700 text-gray-300 px-2 py-0.5 rounded-full">{cat.trim()}</span>
                                    ))}
                                </div>
                            )}

                            <div className="flex items-center gap-3 border-t border-gray-800 pt-3">
                                <img className="w-9 h-9 rounded object-contain bg-gray-800 p-1" src={canal?.icone} alt={canal?.titulo} />
                                <div className="flex flex-col min-w-0">
                                    <span className="text-base font-medium text-orange-400">{canal?.titulo}</span>
                                    <span className="text-sm text-gray-500">{canal?.evento?.inicio_formatado} - {canal?.evento?.fim_formatado}</span>
                                </div>
                                <img className="w-4 ml-auto flex-shrink-0" src={canal?.evento?.classificacao} />
                            </div>

                            {canal?.evento?.subtitulo && (
                                <p className="text-base text-gray-300">{canal?.evento?.subtitulo}</p>
                            )}
                            <p className="text-sm text-gray-400 font-light leading-relaxed">{canal?.evento?.descricao}</p>
                        </>
                    )}
                </div>

                {/* Mobile: grade de canais */}
                <div className="lg:hidden px-4 pt-5 pb-8 overflow-y-auto">
                    <h2 className="text-base font-semibold text-gray-400 uppercase tracking-widest mb-3">Mais canais</h2>
                    <div className="flex flex-row flex-wrap">
                        {canais.map((c, index) => (
                            <div onClick={() => mudarCanal(c)} id="epg_image_container" key={`item-${index}`} className="m-1 item">
                                <div className="bg-gray-800 rounded cursor-pointer">
                                    <img id="channel_icon" src={c.icone} alt={c.titulo} />
                                    <div id="epg_image" className="absolute top-0 w-full h-full">
                                        <div className="absolute w-full h-full flex flex-col justify-center p-2 bg-gradient-to-t from-black via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-200">
                                            <i className="fa fa-play-circle text-3xl self-center"></i>
                                            <div className="flex items-center gap-1 mt-auto">
                                                <span className="truncate text-sm font-medium">{c?.evento?.titulo}</span>
                                            </div>
                                        </div>
                                        <img onError={e => { e.target.error = null; e.target.style.display = 'none' }} src={c?.evento?.imagem} alt={c.evento?.titulo} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </main>
        </div>
    )
}

export default Watch;